export const BASE_URL = "https://case-cubo.onrender.com/user"
